/**
 * @sync-target レクシンユーザーメッセージ一覧 > 04_プッシュ通知一覧
 */
export const PUSH_NOTIFICATION_MESSAGES = {
  DOCUMENT_GENERATION: {
    SUCCESS_TITLE: "生成完了通知",
    FAILURE_TITLE: "生成失敗通知",
    SUCCESS_SAME_PROJECT: (projectName: string, docName: string) =>
      `${projectName}の${docName}生成が完了しました` as const,
    SUCCESS_OTHER_PROJECT: (docName: string) => `${docName}の生成が完了しました` as const,
    FAILURE_SAME_PROJECT: (projectName: string, docName: string) =>
      `${projectName}の${docName}生成に失敗しました` as const,
    FAILURE_OTHER_PROJECT: (docName: string) => `${docName}の生成に失敗しました` as const,
  },
  APP_DEVELOPMENT: {
    SUCCESS_TITLE: "アプリ生成完了",
    FAILURE_TITLE: "アプリ生成失敗",
    SUCCESS: (spaceName: string) => `${spaceName}のアプリ生成が完了しました` as const,
    FAILURE: (spaceName: string) => `${spaceName}のアプリ生成に失敗しました` as const,
  },
} as const;
